module.exports = __webpack_public_path__ + "img/design03.f85fb89d.png";